export const billsSelector = ({ sessionData: { bills } }) => bills;
